import InvestmentPhilosophyBanner from './InvestmentPhilosophyBanner';
import InvestmentPhilosophySection from './InvestmentPhilosophySection';

function InvestmentPhilosophy() {
  return (
    <div>
      <InvestmentPhilosophyBanner />
      <InvestmentPhilosophySection />
    </div>
  );
}

export default InvestmentPhilosophy;